import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import FeedbackSubmissionLayer from "./FeedbackSubmissionLayer";


const FeedbackSubmissionPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Feedback Submissions" />

        {/* FloorMapLayer */}
        <FeedbackSubmissionLayer />
      </MasterLayout>
    </>
  );
};

export default FeedbackSubmissionPage;
